import { cache } from 'utils';
import { LOADING, SUCCESS, FAIL, CANCELED } from 'constants';

const storage = () => {
  return cache.get('fb_storage_ref');
};

export const getURL = (item, is_group) =>
  storage()
    .ref(`${is_group ? 'groups' : 'users'}/${item.user_id}/${item.file_id}${item.ext || ''}`)
    .getDownloadURL();

export const upload = (upload, update) => {
  const file = cache.get(`uploading_${upload.file_id}`);
  const metadata = {
    contentType: file.type,
    contentDisposition: `attachment; filename*=UTF-8''${encodeURI(file.name)}`
  };
  const onProgress = snapshot => {
    update({ ...upload, loaded: snapshot.bytesTransferred, total: snapshot.totalBytes, status: LOADING });
  };

  const onError = err => {
    err.code !== 'storage/canceled' && update({ ...upload, status: FAIL });
  };
  const onComplete = () => {
    update({ ...upload, status: SUCCESS });
  };

  update({ ...upload, loaded: 0, total: file.size, status: LOADING });

  let file_ref = storage()
    .ref(`tmp/${upload.user_id}/${upload.file_id}`)
    .put(file, metadata);

  file_ref.on('state_changed', onProgress, onError, onComplete);
  let upload_meta = cache.get(`uploading_meta_${upload.file_id}`);
  upload_meta.ref = file_ref;
  cache.set(`uploading_meta_${upload.file_id}`, upload_meta);
};

export const cancel = file_id => {
  const { ref, update, upload } = cache.get(`uploading_meta_${file_id}`);
  ref && ref.cancel() && update && update({ ...upload, status: CANCELED });
  cache.remove(`uploading_${file_id}`);
  cache.remove(`uploading_meta_${file_id}`);
};



// WEBPACK FOOTER //
// ./src/utils/uploader.js